import { axios } from '@/lib/axios';
import { useQuery } from 'react-query';

export type VideoQuizDomainV2 = {
    id: number;
    title: string;
};

export type VideoQuizDomainFilterResponseV2 = {
    domains: VideoQuizDomainV2[];
    size: number;
    truncated: boolean;
};

type Params = {
    search?: string;
    size?: number;
    enabled?: boolean;
};

const getVideoQuizDomains = (params: {
    search?: string;
    size?: number;
}): Promise<VideoQuizDomainFilterResponseV2> =>
    axios.get('/api/quiz/v2/library/video-quiz/domains', {
        params: {
            search: params.search || undefined,
            size: params.size ?? 50,
        },
    });

export const useVideoQuizDomains = ({ search, size = 50, enabled = true }: Params) =>
    useQuery({
        queryKey: ['video-quiz-domains', search ?? '', size],
        queryFn: () => getVideoQuizDomains({ search, size }),
        enabled,
        keepPreviousData: true,
    });
